/**
 * Output Categories - 5 ana kategori
 * Her kategori bir prefix, renk ve sıralama bilgisi taşır
 */
export const OUTPUT_CATEGORIES = {
  PRIZE: {
    id: 'PRIZE',
    label: 'Priz',
    prefix: 'PRZ',
    color: '#4CAF50',
    order: 1,
  },
  LIGHTING: {
    id: 'LIGHTING',
    label: 'Aydınlatma',
    prefix: 'AYD',
    color: '#FFC107',
    order: 2,
  },
  MACHINE: {
    id: 'MACHINE',
    label: 'Makine',
    prefix: 'MKN',
    color: '#2196F3',
    order: 3,
  },
  MOTOR_LOADS: {
    id: 'MOTOR_LOADS',
    label: 'Motor Yükleri',
    prefix: 'MTR',
    color: '#00BCD4',
    order: 4,
  },
  WEAK_CURRENT: {
    id: 'WEAK_CURRENT',
    label: 'Zil-İnterkom',
    prefix: 'ZAK',
    color: '#9C27B0',
    order: 5,
  },
  PANEL: {
    id: 'PANEL',
    label: 'Panel',
    prefix: 'PNL',
    color: '#FF5722',
    order: 6,
  },
};
